module.exports = __webpack_public_path__ + "static/media/camera.234a4ab9.svg";